import { FeatureFlag } from 'src/models/platform/_types';
import { isTrainer } from 'src/models/user/utils';

import type { Session } from 'src/models/session/_types';
import type { User } from 'src/models/user/_types';

/**
 * Per-user resolution of whether the new "Dreamcoat" navigation/chrome applies.
 * Mirrors the server logic in `PlatformTabsSerializerDefaults#dreamcoat_active?`
 * so the React chrome and the serialized tabs always agree:
 *
 * - `Dreamcoat Frame` forces the new nav on for the whole gym (no toggle).
 * - `Dreamcoat Opt In` only gates the per-staff-user toggle; it takes effect for
 *   a staff member who has individually opted in (`user.dreamcoatNav`).
 * - Clients always stay on the old nav.
 *
 * Lives in its own module (not `usePermissionCheck`) so that `hasFeatureFlag`
 * can depend on it without creating a circular import.
 */
export const isDreamcoatActive = (
  session?: Session | null,
  user?: User | null
): boolean => {
  if (!session) {
    return false;
  }

  const flags = session.featureFlags ?? [];

  if (flags.includes(FeatureFlag.DreamcoatFrame)) {
    return true;
  }

  return (
    flags.includes(FeatureFlag.DreamcoatOptIn) &&
    isTrainer(user ?? undefined) &&
    !!user?.dreamcoatNav
  );
};
